<!-- Exit point -->
<app-form-group>
  <label for="exitPoint">Exit point</label>
  <app-select [ngModel]="exitPoint" (ngModelChange)="onExitPointChanged($event)" [optionsProvider]="exitPointProvider"
              [formatter]="exitPointFormatter" dataKey="name" required placeholder="– Select exit point –"
              id="exitPoint">
    <div class="invalid-feedback">Please select an exit point</div>
  </app-select>
</app-form-group>

<!-- ETD -->
<app-form-group>
  <label for="portEtd">ETD port</label>
  <app-date-field [ngModel]="etdPort" (ngModelChange)="onPortEtdChanged($event);" [calendarStartDate]="etaPort"
                  id="portEtd" [required]="!isWaitingForOrders()"></app-date-field>
</app-form-group>

<!-- Error messages -->
@if (etdPortIsSameOrAfterNextPort()) {
  <span class="ng-invalid invalid-feedback mb-2">First next port should be after etd port</span>
}
@if (etdPortIsSameOrBeforeLastBerthWithVisitTime()) {
  <span class="ng-invalid invalid-feedback mb-2">Etd port should be after last berth with a visit time</span>
}

<!-- Show ATD port -->
@if (showAtdPort() && !isAdmin()) {
  <div>
    <app-form-group>
      <label for="portAtd-card">ATD Port</label>
      <app-date-field [ngModel]="atdPort" [disabled]="atdPortReported" (ngModelChange)="onAtdPortChanged($event)"
                      id="portAtd-card"></app-date-field>
    </app-form-group>
  </div>
}
@if (atdPortInFuture) {
  <span class="ng-invalid invalid-feedback mb-2">Atd port in the future is not allowed!</span>
}

<!-- Admin -->
@if (isAdmin() || VisitContext.isAtaAtdModifiable()) {
  <app-register-atd-port></app-register-atd-port>
}
